
      import API from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../graylog2-server/graylog2-web-interface/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!./commonStyles.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!./commonStyles.css";
       export default content && content.locals ? content.locals : undefined;
